import { render, staticRenderFns } from "./AdminHospitalPlanList.vue?vue&type=template&id=17ddc98e&scoped=true"
import script from "./AdminHospitalPlanList.vue?vue&type=script&lang=js"
export * from "./AdminHospitalPlanList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ddc98e",
  null
  
)

export default component.exports